export class ContainerTranslation {
    id: number;
    locale: string;
    name: string;
    column_1_name: string;
    column_2_name: string;

    /**
     * constructor
     *
     * @param {ContainerTranslation} init
     */
    public constructor(init?: ContainerTranslation) {
        if (!!init) {
            Object.assign(this, init);
        }
    }
}
